<div class="avi-legend">
    <cds-button
        (click)="handleLegendClick()"
        action="flat"
        class="avi-legend__button"
        size="sm"
    >
        <div
            #colorIcon
            *ngIf="labelData.color"
            class="avi-legend__color-icon"
        ></div>
        <span
            class="avi-legend__placeholder"
            *ngIf="!labelData.color && labelData.forceAlign"
        ></span>
        <div class="avi-legend__label">{{ labelData.label }}</div>
        <ng-content></ng-content>
    </cds-button>
</div>
